<div class="container-dynamic-attrs">
  <div #containerAttrs></div>
</div>
